<template>
    <div class="whole-container">
       
        <div class="body-center" style="display: grid;width: inherit;">
            <div class="right-label">
                <div class="breadcrumb inner-center" style="width: 1200px;font-size: 15px;position: absolute;top: 55px;left: 180px;display: flex;">
                    <a class="breadcrumb-item" style="margin-right: 10px;" @click="homePage()">首页</a>
                    <i class="el-icon-arrow-right" style="margin-right: 10px;line-height: 2;"></i>

                    <a class="breadcrumb-item" style="margin-right: 10px;">{{workTypeName}}</a>
                    <i class="el-icon-arrow-right" style="margin-right: 10px;line-height: 2;"></i>

                    <a class="breadcrumb-item" style="margin-right: 10px;">{{courseName}}</a>
                </div>
               
                    <!-- <a class="breadcrumb-item" href="https://ke.qq.com/course/list?mt=1001">IT·互联网</a>
                    <i class="el-icon-arrow-right"></i>
                    
                    
                    <a class="breadcrumb-item" href="https://ke.qq.com/course/list?mt=1001&amp;st=2004">前端开发</a>
                    <i class="el-icon-arrow-right"></i>
                    
                    
                    <a class="breadcrumb-item" href="https://ke.qq.com/course/list?mt=1001&amp;st=2004&amp;tt=3353">前端零基础</a> -->
                    <!-- <i class="el-icon-arrow-right"></i> -->
                    
                    <!-- <a class="breadcrumb-item item--tt" href="https://ke.qq.com/course/402315">【云知梦】手机微信开发/微信公众号</a> -->
                

                <div class="total-info" style="height: 420px;width: 1200px;margin: auto;">
                    <div style="display: flex;margin: 80px 0;">
                        <div class="train-img-box">
                            <div class="left pull-left  no-full-time" style="position: relative;">
                                <div class="course_img" style="position: absolute;">{{courseName}}</div><img
                                    src="../../../static/img/courseBack.jpg" class="left pull-left">
                            </div>
                        </div>
                        <div class="train-info">
                            <ul style="width: 532px;
                            height: 300px;
                            position: relative;">
                                <span id="keshi2"
                                    style="position: absolute;right: 0;top:10px;color: #999;">{{coursePeriod}}课时</span>
                                <li><span style="font-size: 24px;color: black;">{{courseName}}</span></li>

                                <li style="margin-top: 110px;font-size: 28px;"><span></span>
                                    <!-- <span
                                        style="color: #fd573f;">￥{{coursePrice}}</span> -->
                                    </li>
                                <!-- <li v-if="choiceState == null"><button style="position: absolute;
                                    bottom: 0;
                                    padding: 0 37px;
                                    font-size: 18px;
                                    line-height: 46px;
                                    border-radius: 10px;
                                    height: 48px;
                                    color: #fff;
                                    background-color: #fc583d;
                                    border-color: #fc583d;
                                    cursor: pointer;
                                    " @click="BuyItNow()">立即购买</button></li> -->


                                <li v-if="choiceState != null"><button style="position: absolute;
                                    bottom: 0;
                                    padding: 0 37px;
                                    font-size: 18px;
                                    line-height: 46px;
                                    border-radius: 10px;
                                    height: 48px;
                                    color: #fff;
                                    background-color: #fc583d;
                                    border-color: #fc583d;
                                    cursor: pointer;
                                    " @click="StudyItNow()">立即学习</button></li>


                                <li class="canxunrenshu" style="position: absolute;right: 0;bottom: 0;;color: #999;">
                                    学习人数： {{courseStudyNum}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex;margin: 0 auto;width: 1200px;">
                <div class="right-label1">
                    <div class="train-detail">
                        <div class="md2018040804lty ">
                            <div class="slideTxtBox" id="js_control_details">
                                <el-tabs v-model="activeName" @tab-click="handleClick">
                                    <el-tab-pane label="课程目录" name="first">
                                        <div v-if="activeName === 'first'">

                                            <li v-for="(item,index) in courseChapterList" class="xtype2 xtype2-t1"
                                                :key="index" style="margin: 25px 15px;display: flex;">
                                                <div>
                                                    <span class="verflag"
                                                        style="overflow: hidden; white-space: nowrap;text-overflow: ellipsis;width: 350px;font-size: 15px;font-weight: bold;">【视频】</i><span
                                                            class="textx text-overflow">{{item.chapterName}}</span></span>

                                                </div>
                                            </li>
                                        </div>

                                    </el-tab-pane>
                                    <el-tab-pane label="课程简介" style="height: 600px;" name="second">
                                        <div v-if="activeName === 'second'">
                                            <div v-if="courseIntroflag"
                                                style="text-align: center;color: #888888;height: 500px;line-height: 600px;">
                                                暂无课程简介</div>

                                            <div style="text-indent: 2em; color: #888888;height: 500px;"
                                                v-html="courseDetailInfo.courseIntro">
                                            </div>
                                        </div>

                                    </el-tab-pane>
                                    <el-tab-pane label="名师风采" style="height: 600px;" name="third">
                                        <div v-if="activeName === 'third'">

                                            <div v-if="teacherIntroflag"
                                                style="text-align: center;color: #888888;height: 500px;line-height: 600px;">
                                                暂无老师简介</div>

                                            <div v-html="courseDetailInfo.teacherIntro"></div>

                                        </div>

                                    </el-tab-pane>
                                    <el-tab-pane label="课程评论" style="height: 600px;" name="fourth">

                                        <div v-if="activeName === 'fourth'" class="item"
                                            style="width: 100%;display: block; min-height: 600px;">

                                            <textarea ref="textarea" :rows="5" maxlength="500"
                                                class="el-textarea__inner"
                                                placeholder="请填写课程评论">{{evaluateVal1}}</textarea>

                                            <div class="edit-bt">
                                                <div class="star-area ver-top" style="display: flex;">
                                                    <span id="scoureId" class="font-16 color-333 ver-top"
                                                        style="margin-right: 5px;font-size: 18px;font-weight: bold;">星级</span>
                                                    <el-rate v-model="star1" :colors="colors" style="margin-top: 5px;">
                                                    </el-rate>
                                                </div>
                                                <ul class="lab-list ver-top" id="js_lab_list">
                                                </ul>
                                                <p class="ver-top text-right">
                                                    <button type="button" class="form-btn form-btn-blue"
                                                        style="position: absolute;right: 20px;"
                                                        @click="evaluate">评论</button>
                                                </p>
                                            </div>
                                            <div class="comment-area">
                                                <p class="color-666 comm-tit bgcolor-f6f5fa">
                                                    全部评论<span id="commentSize">({{count}})</span>
                                                </p>


                                                <div v-for="(item,index) in evaluateListData" :key="index"
                                                    class="comm-list" id="commentInfoDiv">
                                                    <div class="comm-box clearfix">
                                                        <div class="tx pull-left text-center">
                                                            <div class="md-2018040801-lty"><img
                                                                    src="../../../static/img/head.svg" alt=""
                                                                    onerror="this.onerror=null;this.src='/img/head.svg'">
                                                            </div>
                                                            <p class="nc font-14">{{item.user_name}}</p>
                                                        </div>
                                                        <div class="comm-con">
                                                            <v-rate class="star-num star-1" v-model="item.rate"
                                                                :disabled="true"></v-rate>
                                                            <p class="font-14">{{item.content}}</p><span
                                                                class="comm-t color-999 font-14">{{item.create_time}}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <p v-if="evaluateFlag" class="none-commentlty text-center font-14 hide">
                                                    暂无评论
                                                </p>
                                            </div>

                                        </div>

                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin: 15px 10px;">
                    <div class="operation-tips">
                        <h4>
                            <img src="../../../static/img/operation-tips.png">
                            <span>移动端学习</span>
                        </h4>
                        <div class="md2018041703lty">
                            <div class="ewm bgcolor-fff">
                                <img src="../../../static/img/gongzhongzj.jpg" alt="">
                                <p class="font-14 l-m">扫码了解更多</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    // import vuebeauty from 'vue-beauty'
    // import 'vue-beauty/package/style/vue-beauty.min.css'
    //  Vue.use(vuebeauty)
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
                star1: 0,
                evaluateVal: '',
                evaluateVal1: '',
                courseName: '',
                accessoryFlag: false,
                thatMaterialList: [],
                flag: false,
                count: 0,
                evaluateListData: [],
                activeName: 'first',
                courseIntroflag: false,
                teacherIntroflag: false,
                courseDetailInfo: {
                    courseIntro: '',
                    teacherName: '',
                    teacherIntro: '',
                    courseHourList: []
                },
                evaluateFlag: false,
                courseChapterList: [],
                coursePeriod: 0,
                courseStudyNum: 0,
                testCount: 0,
                coursePrice: 0,
                courseId: 0,
                choiceState: 0,
                workTypeName:''
            }
        },
        beforeMount() {



        },
        created() {
            //加载课程评价
            this.workTypeName = this.$route.params.workTypeName;
            this.loadEvaluateListData(this.$route.params.courseId);


            this.courseDetail(this.$route.params.courseId);

        },
        methods: {
            homePage(){
                this.$router.push({path:'/train'});
            },
            evaluate() {
                if (this.$refs.textarea.value == '') {
                    this.$message({
                        message: '请填写评价内容',
                        type: 'warning'
                    });
                    return false;
                } else if (this.star1 === 0) {
                    this.$message({
                        message: '请打分',
                        type: 'warning'
                    });
                    return false;
                }
                const loading = this.$loading({
                    lock: true,
                    text: '评价中，请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let parames = new URLSearchParams();

                parames.append('userId', this.$storage.get("declareUser").id);

                parames.append('score', this.star1);

                parames.append('evalContent', this.$refs.textarea.value);

                parames.append('courseId', this.courseId);

                parames.append('courseName', this.courseName);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/addComment', parames).then(resp => {
                    if (resp.data.code === '1') {
                        loading.close();
                        this.$message({
                            showClose: true,
                            message: '评价成功，等待管理员审核！',
                            type: 'success'
                        });
                        this.$refs.textarea.value = '';
                        this.star1 = 0;

                    } else {
                        this.$message({
                            showClose: true,
                            message: '评价失败！',
                            type: 'error'
                        });
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            StudyItNow() {
                this.$router.push({ path: '/personalCenter' })
            },
            BuyItNow() {

                this.$confirm('课程价格' + this.coursePrice + ', 确定购买么?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //确定
                    let parames = new URLSearchParams();
                    parames.append('order_status', 1);
                    parames.append('order_amount', this.coursePrice);

                    parames.append('userId', this.$storage.get("declareUser").id);

                    parames.append('courseIds', this.courseId + ',');

                    //获取 当前等级下的上传资料 列表
                    this.$axios.post(this.serverUrl + '/addOrderRecordCourse', parames).then(resp => {

                        if (resp.data.code === 1) {

                            const { href } = this.$router.resolve({
                                name: "coursePay",
                                params: {}
                            });
                            this.$storage.set('orderRecord', resp.data.orderRecord)
                            window.open(href, '_blank');

                            let _this = this;
                            this.$confirm('确认支付完毕?', '提示', {
                                cancelButtonText: '取消',
                                confirmButtonText: '确定',
                                type: 'warning'
                            }).then(() => {

                                this.$router.push({ path: '/personalCenter' })

                            }).catch(() => {

                            });

                        } else {
                            this.$message({
                                showClose: true,
                                message: '服务器繁忙，稍后重试！',
                                type: 'error'
                            });
                        }
                    }).catch(err => {
                        this.$message({
                            showClose: true,
                            message: '服务器繁忙，稍后重试！',
                            type: 'error'
                        });
                    })






                }).catch(() => {
                    //取消


                });

            },
            centerStudy(item) {
                const { href } = this.$router.resolve({
                    path: "/video/" + this.$route.params.courseId + "/" + this.$route.params.classId + "/" + item.chapterId + "/2",
                });
                window.open(href, '_blank');
            },
            secondToDate(result) {
                var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                var m = Math.floor((result / 60) % 60) < 10 ? '0' + Math.floor((result / 60) % 60) : Math.floor((result / 60) % 60);
                var s = Math.floor(result % 60) < 10 ? '0' + Math.floor(result % 60) : Math.floor(result % 60);
                return (result = h + ':' + m + ':' + s);
            },
            loadEvaluateListData(courseId) {
                let parames = new URLSearchParams();
                parames.append('courseId', courseId);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/commentList', parames).then(resp => {

                    if (resp.data.data.length > 0) {
                        let ArrayList = [];
                        for (let i = 0; i < resp.data.data.length; i++) {
                            let evaluateEnter = resp.data.data[i];
                            let evaluateGo = {
                                header_img: '',
                                user_name: '',
                                rate: 0,
                                create_time: '',
                                content: ''
                            };
                            if (evaluateEnter.headPath != null) {
                                evaluateGo.header_img = this.serverUrl + this.prefiexUrl + evaluateEnter.headPath; //用户头像
                            } else {
                                evaluateGo.header_img = '../../../static/img/head.svg';
                            }

                            evaluateGo.user_name = evaluateEnter.userName; //用户姓名
                            evaluateGo.rate = evaluateEnter.score; //用户评分
                            evaluateGo.content = evaluateEnter.evalContent; //评价内容
                            evaluateGo.create_time = evaluateEnter.evalTime.substring(0, 10);

                            ArrayList.push(evaluateGo);
                        }
                        this.evaluateListData = ArrayList;
                        this.count = resp.data.data.length

                        this.flag = true;
                    } else {

                        this.evaluateFlag = true;
                        this.count = 0;

                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            handleClick(tab) {
                console.log(tab.name);
                this.activeName = tab.name;
            },
            courseDetail(courseId) {
                let parames = new URLSearchParams();
                parames.append('courseId', courseId);
                parames.append('userId', this.$storage.get("declareUser").id);
                parames.append('classType', 2);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectWorkTypeCourse', parames).then(resp => {
                    if (resp.data.code === '1') {
                        this.courseName = resp.data.data.courseName;  //课程名称
                        this.coursePeriod = resp.data.data.coursePeriod; //课程课时
                        this.courseId = resp.data.data.courseId;  //课程id
                        this.coursePrice = resp.data.data.coursePrice; //课程价格
                        this.choiceState = resp.data.data.choiceState;  //课程选择状态
                        this.courseStudyNum = resp.data.data.courseStudyNum; //课程学习人数

                        //课程简介
                        if (resp.data.data.courseSummary === null || resp.data.data.courseSummary === '' || resp.data.data.courseSummary === undefined) {
                            this.courseIntroflag = true;
                            this.courseDetailInfo.courseIntro = '';
                        } else {
                            this.courseDetailInfo.courseIntro = resp.data.data.contentSummary;
                        }
                        //老师姓名
                        this.courseDetailInfo.teacherName = resp.data.data.userName;
                        //老师简介
                        if (resp.data.data.userResume === null || resp.data.data.userResume === '' || resp.data.data.userResume === undefined) {
                            this.teacherIntroflag = true;
                            this.courseDetailInfo.teacherIntro = '';
                        } else {
                            this.courseDetailInfo.teacherIntro = resp.data.data.userResume;
                        }

                        let ArrayList = [];
                        resp.data.data.courseChapterVos.forEach(element => {
                            if (element.testQueNum != 0) {
                                this.testCount++;
                            }
                            let courseChapterVoObjectEnter = {
                                chapterId: 0, //章节id
                                chapterName: '', //章节名称
                                totalHourMinuteSecond: '', //章节 总 时分秒
                                totalSecond: '', //章节 总时长 秒
                                atMostTime: 0, //该章节最多学习到多少秒过
                                speedProgress: '', //学习到多少分 多少秒  用于显示 类型字符串
                                aleryHourMinuteSecond: '', //学习到多少秒 用于直接定义视频播放初始位置  类型数值 秒
                                resourcePath: 0, //资源路径
                                courseType: 0,
                                classHour: 0,
                                studyState: 0,
                                schedulePercentage: 0,
                                classId: 0,
                                courseId: 0,
                                testQueNum: 0,
                                testPass: 0,
                                testCount: 0
                            };
                            courseChapterVoObjectEnter.testQueNum = element.testQueNum;
                            courseChapterVoObjectEnter.testPass = element.testPass;
                            courseChapterVoObjectEnter.testCount = element.testCount;
                            courseChapterVoObjectEnter.classId = element.classId;
                            courseChapterVoObjectEnter.courseId = element.courseId;
                            courseChapterVoObjectEnter.schedulePercentage = ((element.speedProgress / element.totalSecond).toFixed(4) * 100).toFixed(2);
                            //章节名称
                            //章节id
                            courseChapterVoObjectEnter.chapterId = element.chapterId;
                            //章节名称
                            courseChapterVoObjectEnter.chapterName = element.chapterName;
                            //章节总时长
                            courseChapterVoObjectEnter.totalHourMinuteSecond = this.secondToDate(element.totalSecond);
                            courseChapterVoObjectEnter.aleryHourMinuteSecond = this.secondToDate(element.speedProgress);
                            courseChapterVoObjectEnter.totalSecond = element.totalSecond;
                            this.courseChapterList.push(courseChapterVoObjectEnter);
                        });
                    } else {
                        this.courseIntroflag = true;
                        this.teacherIntroflag = true;
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }
        }
    }
</script>

<style scoped>

.icon-font {
    font-family: webfont;
    font-style: normal;
    font-weight: 400;
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    font-size: 16px;
    position: relative;
    vertical-align: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.l-max .inner-center, .l-media .inner-center {
    font-size: 14px;
    width: 1200px;
    margin: auto;
}

.breadcrumb .breadcrumb-item {
    float: left;
}

.breadcrumb .icon-font {
    margin: 8px 10px 0;
    float: left;
    font-size: 14px;
}

.breadcrumb a {
    color: #333;
}

.breadcrumb {
    line-height: 30px;
    margin-bottom: 20px;
}
.inner-center {
    margin-left: auto;
    margin-right: auto;
}












    div /deep/ .el-table--fit {
        border-right: 0;
        border-bottom: 0;
        /* margin-left: 20px !important; */
    }

    div /deep/ .el-table__body,
    .el-table__footer,
    .el-table__header {
        table-layout: fixed;
        border-collapse: separate;
        width: 100% !important;
    }

    .text-overflow {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .md2018040804lty .main-con .c-con li .c-t {
        font-style: normal;
    }

    span.verflag {
        display: inline-block;
        vertical-align: middle;
    }

    .course-num {
        float: right;
        font-size: 14px;
        color: #e51212;
        margin-right: 6%;
        line-height: 50px;
    }

    .xbtn-1125 {
        /* min-width: 60px; */
        /* max-width: 70px; */
        width: 70px;
        display: inline-block;
        height: 26px;
        line-height: 24px;
        /* padding: 0 11px; */
        color: #fff;
        font-size: 12px;
        -webkit-border-radius: 4px 4px;
        -moz-border-radius: 4px 4px;
        border-radius: 4px 4px;
        text-align: center;
        background: #4d95ff;
        margin-left: 10px;
        cursor: pointer;
    }

    .pull-right {
        float: right;
    }

    .md2018040804lty .slideTxtBox .main-con .c-con li {
        padding: 0 15px;
        height: 50px;
        line-height: 50px;
    }

    .font-14 {
        font-size: 14px;
    }

    .color-666 {
        color: #666;
    }

    .md2018040804lty .slideTxtBox .main-con .course-box.active .c-con {
        display: block;
        opacity: 1;
    }

    .font-weight {
        font-weight: bold;
    }

    .md2018040804lty .slideTxtBox .main-con .course-tit .order-num {
        font-size: 18px;
        color: #161616;
        margin-right: 20px;
    }

    .md2018040804lty .slideTxtBox .main-con .course-box .course-tit {
        background: #f6f5fa;
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        border-bottom: 1px solid #EAEAEA;
    }

    div /deep/ .el-tabs__header {
        margin: 0 25px;
        padding: 0;
        position: relative;
    }

    .js-191125btn {
        width: 70px;
        display: inline-block;
        height: 26px;
        color: white;
        line-height: 24px;
        /* padding: 0 11px; */
        color: #fff;
        font-size: 12px;
        -webkit-border-radius: 4px 4px;
        -moz-border-radius: 4px 4px;
        border-radius: 4px 4px;
        text-align: center;
        background: #4d95ff;
        margin-left: 10px;
        cursor: pointer;
    }

    div /deep/ .ant-tabs-nav .ant-tabs-tab {
        display: inline-block;
        height: 100%;
        margin-right: 24px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
        padding: 8px 35px;
        -webkit-transition: color .3s cubic-bezier(.645, .045, .355, 1);
        transition: color .3s cubic-bezier(.645, .045, .355, 1);
        cursor: pointer;
        text-decoration: none;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }


    .form-btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        height: 40px;
    }

    .edit-bt>p button {
        width: 100px;
    }

    .ver-top {
        display: inline-block;
        vertical-align: top;
    }

    .star-area {
        width: 200px;
    }

    .edit-bt {
        margin: 20px 0 30px 0;
    }










    .item {
        display: none;
        padding: 15px 20px;
    }

    div /deep/ .el-tabs__item {
        padding: 0 45px;
        height: 40px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 40px;
        display: inline-block;
        list-style: none;
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        position: relative;
    }

    .md2018040804lty .slideTxtBox .main-con .l-con .item {
        display: none;
        padding: 30px 20px;
    }

    .md2018040804lty .main-con .c-con li .c-t {
        font-style: normal;
    }

    span.verflag {
        display: inline-block;
        vertical-align: middle;
    }

    .cusfont-lubo-:before {
        content: "\e719";
    }

    .md2018040804lty .main-con .c-con li .cusfont {
        font-size: 22px;
        vertical-align: middle;
    }

    .course-progress {
        font-size: 16px;
        color: #999;
        margin-right: 4px;
        font-weight: bold;
    }

    .jindu200610>div span {
        position: absolute;
        top: -18px;
        color: #ccc !important;
        width: 50px;
        right: -25px;
        text-align: center;
        font-size: 12px !important;
    }

    .jindu200610>div {
        position: absolute;
        height: 100%;
        border-radius: 6px;
        background: #2b83f3;
    }

    .jindu200610 {
        width: 236px !important;
        position: absolute !important;
        border-radius: 6px;
        height: 6px;
        background-color: #ddd;
        margin-left: 30px;
        top: 24px;
        right: 207px;
    }

    .pull-right {
        float: right;
    }

    .md2018040804lty .slideTxtBox .main-con .c-con li {
        padding: 0 15px;
        height: 50px;
        line-height: 50px;
        position: relative !important;
    }

    .md2018040804lty .slideTxtBox .main-con .course-box.active .c-con {
        display: block;
        opacity: 1;
    }

    .cusfont-under:before {
        content: "\e6ef";
    }

    .cusfont {
        font-family: "cusfont" !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md2018040804lty .right-down-parent i.cusfont {
        position: relative;
        transition: all .5s;
    }

    .md2018040804lty .slideTxtBox .main-con .course-box.active .right-down-parent i.cusfont {
        transform: rotate(-180deg);
    }

    .md2018040804lty .slideTxtBox .main-con .course-box .course-tit .right-down-parent {
        margin-right: -15px;
        padding: 0 15px;
        cursor: pointer;
        position: relative;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
    }

    .pull-left {
        float: left;
    }

    .font-weight {
        font-weight: bold;
    }

    .md2018040804lty .slideTxtBox .main-con .course-tit .order-num {
        font-size: 18px;
        color: #161616;
        margin-right: 20px;
    }

    .md2018040804lty .slideTxtBox .main-con .course-box .course-tit {
        background: #f6f5fa;
        height: 50px;
        line-height: 50px;
        padding: 0 15px;
        border-bottom: 1px solid #EAEAEA;
    }

    .md2018040804lty .slideTxtBox .main-con .l-con .item {
        display: none;
        padding: 30px 20px;
    }

    .md2018040804lty .slideTxtBox .main-con .l-con {
        width: 945px !important;
        border-radius: 4px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .comm-box {
        padding: 20px 0;
        border-bottom: 1px solid #f6f5fa;
    }

    .md2018040804lty .slideTxtBox .main-con {
        padding: 30px 0;
    }

    .md2018040804lty .slideTxtBox .hd li {
        float: left;
        width: 110px;
        text-align: center;
        padding-bottom: 15px;
        border-bottom: 3px solid transparent;
        margin-right: 42px;
        cursor: pointer;
    }

    .md2018040804lty .slideTxtBox .hd li.on {
        border-bottom-color: #00ca47;
        color: #002856;
    }

    .color-333 {
        color: #333;
    }

    .font-16 {
        font-size: 16px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .bgcolor-fff {
        background: #fff;
    }

    .train-intr p {
        min-height: 40px;
        position: relative;
        color: #5a5a5a;
        font-size: 14px;
    }

    .train-intr-head {
        position: absolute;
        top: -12px;
        left: 20px;
        background-color: #fff;
        color: #002856;
        font-size: 14px;
        padding: 0 10px;
    }

    .train-intr {
        margin-top: 20px;
        border: solid 1px #f5cfcf;
        padding: 10px 20px;
        position: relative;
    }

    .clear {
        clear: both;
    }

    li {
        list-style: none;
    }

    .train-info ul li {
        margin-left: 22px;
        color: #80888b;
        padding-top: 2px;
        font-size: 14px;
    }

    .train-img-box,
    .train-info {
        float: left;
    }

    .pull-left {
        float: left;
    }

    .train-img-box img {
        width: 490px;
        height: 300px;
        border-right: 6px;
    }

    .course_img {
        position: absolute;
        top: 31%;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 49px;
        font-weight: 400;
        letter-spacing: 8px;
        padding: 0 18px;
    }

    .pull-left {
        float: left;
    }

    .train-img-box,
    .train-info {
        float: left;
    }

    .train-info-box {
        margin-top: 20px;
        position: relative;
    }

    .pre-title {
        text-align: center;
        color: #010101;
        border-bottom: solid 1px #f5cfcf;
        font-size: 12px;
        padding-bottom: 10px;
    }

    .layui-btn,
    .layui-input,
    .layui-select,
    .layui-textarea,
    .layui-upload-button {
        outline: 0;
        -webkit-appearance: none;
        transition: all .3s;
        -webkit-transition: all .3s;
        box-sizing: border-box;
    }

    .layui-btn {
        display: inline-block;
        height: 38px;
        line-height: 38px;
        padding: 0 18px;
        background-color: #009688;
        color: #fff;
        white-space: nowrap;
        text-align: center;
        font-size: 14px;
        border: none;
        border-radius: 2px;
        cursor: pointer;
    }

    .layui-btn-sm {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 12px;
    }

    a:link,
    a:visited,
    a:link {
        text-decoration: none;
    }

    .total-title {
        text-align: center;
        font-size: 24px;
        color: #333;
        width: 100%;
        padding-bottom: 7px;
        margin: 0 auto;
        position: relative;
    }

    .total-info-trainclass-score h6 {
        font-size: 12px;
    }

    .total-info-trainclass-score h5 {
        font-size: 20px;
        margin-top: 5px;
    }

    .total-info-trainclass-score {
        position: absolute;
        right: 100px;
        top: 98px;
        width: 46px;
        height: 46px;
        background-size: cover;
        color: #fff;
        padding: 5px;
        text-align: center;
    }

    .total-info {
        padding: 20px;
        background-color: #fff;
    }

    .theme-discuss-box {
        position: absolute;
        top: 80px;
        right: 40px;
        width: 1049px;
        height: 777px;
        z-index: 10002;
        background-color: #fff;
        box-shadow: 0 0 10px #ccc;
        display: none;
    }

    .right-label {
        width: 100%;
        position: relative;
        background-color: #fff;
    }

    .right-label1 {
        width: 910px;
        float: right;
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
        position: relative;
        background-color: #fff;
    }

    .font-14 {
        font-size: 14px;
    }

    .md2018041703lty .ewm .l-m {
        color: #000;
        margin-top: 10px;
    }

    .md2018041703lty .ewm img {
        width: 180px;
        height: 180px;
    }

    .bgcolor-fff {
        background: #fff;
    }

    .md2018041703lty .ewm {
        padding: 30px 36px !important;
        text-align: center;
        margin-bottom: 20px;
    }

    .train-class-tips h4 img,
    .progress-bar-box h4 img,
    .hot-train-class h4 img,
    .operation-tips h4 img,
    .student-info-box h4 img {
        height: 21px;
        margin-left: -10px;
        padding-bottom: 5px;
    }

    .train-class-tips h4,
    .progress-bar-box h4,
    .student-info-box h4,
    .operation-tips h4 {
        color: #ffffff;
        height: 48px;
        background: #346aa9;
        line-height: 48px;
        text-align: center;
        font-size: 15px;
    }

    .operation-tips {
        margin-top: 5px;
    }

    .trainclass-progress-item>span {
        margin-left: 10px;
    }

    .trainclass-progress-item>div {
        float: left;
        margin-top: -12px;
        margin-right: 5px;
    }

    .trainclass-progress-item .progress-box {
        width: 122px;
        height: 8px;
        border-radius: 4px;
        background-color: #f0eff2;
        margin-top: 7px;
        overflow: hidden;
    }

    .trainclass-progress-item>div {
        float: left;
        margin-top: -12px;
        margin-right: 5px;
    }

    .trainclass-progress-item>div:first-child {
        width: 50px;
        text-align: center;
    }

    .trainclass-progress-item {
        width: 235px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .trainclass-progress-item>span {
        margin-left: 10px;
    }

    .trainclass-compul-progress-item .progress-box div {
        height: 100px;
        background-color: #ffa21d;
    }

    .trainclass-progress-item>div {
        float: left;
        margin-top: -12px;
        margin-right: 5px;
    }

    .trainclass-progress-item .progress-box {
        width: 122px;
        height: 8px;
        border-radius: 4px;
        background-color: #f0eff2;
        margin-top: 7px;
        overflow: hidden;
    }

    .trainclass-progress-item-name {
        font-size: 12px;
        margin-top: 10px;
    }

    .trainclass-progress-item>div>img {
        height: 20px;
        margin-top: 10px;
    }

    .trainclass-progress-item>div {
        float: left;
        margin-top: -12px;
        margin-right: 5px;
    }

    .trainclass-progress-item>div:first-child {
        width: 50px;
        text-align: center;
    }

    .trainclass-progress-item {
        width: 235px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .train-class-tips h4 img,
    .progress-bar-box h4 img,
    .hot-train-class h4 img,
    .operation-tips h4 img,
    .student-info-box h4 img {
        height: 21px;
        margin-left: -10px;
        padding-bottom: 5px;
    }

    .train-class-tips h4,
    .progress-bar-box h4,
    .student-info-box h4,
    .operation-tips h4 {
        color: #ffffff;
        height: 48px;
        background: #346aa9;
        line-height: 48px;
        text-align: center;
        font-size: 15px;
    }

    .progress-bar-box {
        width: 100%;
        background-color: #fff;
        margin-top: 5px;
    }

    .progress-bar-box {
        padding-bottom: 40px;
    }

    .trainclass-get h3 {
        font-size: 14px;
        color: #444444;
        margin-bottom: 20px;
    }

    .trainclass-get {
        border: none !important;
    }

    .trainclass-time-tips,
    .trainclass-demand,
    .trainclass-get {
        width: 218px;
        margin: 0 auto;
        border-bottom: solid 1px #e6e6e6;
        padding: 23px 0;
        text-align: center;
    }

    .trainclass-demand:after,
    .trainclass-get:after {
        content: ' ';
        width: 0;
        height: 0;
        overflow: hidden;
        visibility: hidden;
        display: block;
        clear: both;
    }

    .trainclass-demand-item {
        width: 72px;
        margin: 15px auto 0;
    }

    .trainclass-demand-item div {
        font-size: 12px;
        color: #444;
    }

    img {
        border: 0;
        vertical-align: middle;
        cursor: default !important;
    }

    .trainclass-demand-item img {
        height: 23px;
        margin-bottom: 7px;
    }

    .trainclass-demand-item {
        width: 72px;
        margin: 15px auto 0;
    }

    .trainclass-demand h3 {
        font-size: 14px;
        color: #444444;
        margin-bottom: 20px;
    }

    .trainclass-time-tips,
    .trainclass-demand,
    .trainclass-get {
        width: 218px;
        margin: 0 auto;
        border-bottom: solid 1px #e6e6e6;
        padding: 23px 0;
        text-align: center;
    }

    .trainclass-time-tips h6 {
        font-size: 12px;
        color: #444444;
        margin: 20px 0 0 0;
    }

    .trainclass-time-tips-unit {
        color: #002856;
        font-size: 14px;
        vertical-align: -7px;
        margin-left: 5px;
    }

    .trainclass-time-tips-num {
        width: 50px;
        text-align: center;
        height: 47px;
        background-color: red;
        color: #fff;
        font-size: 35px;
        font-family: mynumstyle;
        font-weight: 700;
        border-radius: 5px;
        padding: 5px;
        display: inline-block;
        line-height: 40px;
        margin-right: 1px;
    }

    .trainclass-time-tips h5 {
        color: #002856;
        font-size: 14px;
        margin-bottom: 20px;
    }

    .trainclass-time-tips,
    .trainclass-demand,
    .trainclass-get {
        width: 218px;
        margin: 0 auto;
        border-bottom: solid 1px #e6e6e6;
        padding: 23px 0;
        text-align: center;
    }

    .train-class-tips h4,
    .progress-bar-box h4,
    .student-info-box h4,
    .operation-tips h4 {
        color: #ffffff;
        height: 48px;
        background: #346aa9;
        line-height: 48px;
        text-align: center;
        font-size: 15px;
    }

    .train-class-tips {
        width: 100%;
        background-color: #fff;
        padding: 1px 0;
    }

    .left-label {
        width: 250px;
        margin-top: 20px;
        float: left;
    }

    .body-center {
        display: flex;
    }

    .whole-container {
        background-color: #eee;
        width: 100%;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/courseBuyDetail.vue